export const PROBLEM_TYPE_SKU_BEING_TO_ANOTHER_OFFERING =
  "/problems/product/sku-already-belongs-to-another-offering-for-this-sp";
